const videoPaths = {
  0: "/videos/video0.mp4",
  1: "../videos/video1.mp4",
  2: "../videos/video2.mp4",
  3: "../videos/video3.mp4",
};

const groupVideoPaths = {
  0: {
    experiential: "../videos/0experiential.mp4",
    expression: "../videos/0expression.mp4",
    control: "../videos/0control.mp4",
  },
  1: {
    experiential: "../videos/1experiential.mp4",
    expression: "../videos/1expression.mp4",
    control: "../videos/1control.mp4",
  },
  2: {
    experiential: "../videos/2experiential.mp4",
    expression: "../videos/2expression.mp4",
    control: "../videos/2control.mp4",
  },
  3: {
    experiential: "../videos/3experiential.mp4",
    expression: "../videos/3expression.mp4",
    control: "../videos/3control.mp4",
  },
};

export { videoPaths, groupVideoPaths };
